module.exports = __webpack_public_path__ + "img/Snapshot-min.35492309.png";